import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChartDonutIcon = function ChartDonutIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8539 3.83109C11.2683 4.85496 10.7743 6.02095 9.75043 6.4354C7.54787 7.32697 6 9.48512 6 12C6 12.2557 6.01588 12.5068 6.04652 12.7525C6.1832 13.8486 5.40544 14.8479 4.30936 14.9846C3.21328 15.1213 2.21394 14.3435 2.07726 13.2475C2.0262 12.838 2 12.4216 2 12C2 7.80013 4.58847 4.20962 8.24957 2.72765C9.27344 2.3132 10.4394 2.80723 10.8539 3.83109ZM5.4395 16.9944C6.13038 16.1326 7.3891 15.994 8.25094 16.6849C9.27851 17.5086 10.5791 18 12 18C13.4209 18 14.7215 17.5086 15.7491 16.6849C16.6109 15.994 17.8696 16.1326 18.5605 16.9944C19.2514 17.8563 19.1128 19.115 18.2509 19.8059C16.5393 21.178 14.3629 22 12 22C9.63708 22 7.46068 21.178 5.74906 19.8059C4.88722 19.115 4.74863 17.8563 5.4395 16.9944Z",
      fill: "#12131A",
      fillOpacity: "0.25"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.1461 3.83109C13.5606 2.80723 14.7266 2.3132 15.7504 2.72765C19.4115 4.20962 22 7.80013 22 12C22 12.4216 21.9738 12.838 21.9228 13.2475C21.7861 14.3435 20.7867 15.1213 19.6906 14.9846C18.5946 14.8479 17.8168 13.8486 17.9535 12.7525C17.9841 12.5068 18 12.2557 18 12C18 9.48512 16.4521 7.32697 14.2496 6.4354C13.2257 6.02095 12.7317 4.85496 13.1461 3.83109Z",
      fill: "#12131A"
    })]
  }));
};

ChartDonutIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChartPieIcon = function ChartPieIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10.35 3.44999C10.35 2.81487 9.83356 2.29339 9.20235 2.36381C7.56134 2.5469 5.982 3.12076 4.59985 4.04428C2.8978 5.18155 1.57122 6.798 0.787851 8.68922C0.00448451 10.5804 -0.20048 12.6615 0.198877 14.6692C0.598234 16.6769 1.58398 18.5211 3.03145 19.9685C4.47892 21.416 6.32311 22.4018 8.33082 22.8011C10.3385 23.2005 12.4196 22.9955 14.3108 22.2121C16.202 21.4288 17.8184 20.1022 18.9557 18.4001C19.8792 17.018 20.4531 15.4387 20.6362 13.7976C20.7066 13.1664 20.1851 12.65 19.55 12.65H11.5C10.8649 12.65 10.35 12.1351 10.35 11.5V3.44999Z",
      fill: "#8C8C8C"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.8499 10.3502C22.485 10.3502 23.0065 9.83375 22.9361 9.20254C22.8284 8.23735 22.5852 7.29018 22.2121 6.38941C21.6919 5.13369 20.9295 3.99271 19.9685 3.03163C19.0074 2.07054 17.8664 1.30817 16.6107 0.788029C15.7099 0.414916 14.7627 0.171694 13.7975 0.0640062C13.1663 -0.00641926 12.6499 0.515055 12.6499 1.15018V9.20018C12.6499 9.83531 13.1648 10.3502 13.7999 10.3502H21.8499Z",
      fill: "#12131A"
    })]
  }));
};

ChartPieIcon.defaultProps = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export const CHART_TYPES = [{
  value: 'pie',
  label: 'Pie',
  icon: /*#__PURE__*/_jsx(ChartPieIcon, {})
}, {
  value: 'doughnut',
  label: 'Doughnut',
  icon: /*#__PURE__*/_jsx(ChartDonutIcon, {})
}];